import { activatedDeactivatedOptions } from '@application/utils';
import type { AccordionTab } from '@presentation/components';
import { Accordion, InputRadio, PreferenceList } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { useFormikContext } from 'formik';
import type { FC } from 'react';
import { useMemo } from 'react';
import type {
  MtSettingsBreederPageFormValues,
  MtSettingsBuyerPageFormValues,
} from '@presentation/pages';
import type { ContactPreferencesAccordionProps } from './types';
import * as Styled from '../../styled';

export const ContactPreferencesAccordion: FC<ContactPreferencesAccordionProps> = (props) => {
  const { preferences, mode, onChangeContactPreferenceClick } = props;

  const { translate } = useTranslation();
  const { values } = useFormikContext<
    MtSettingsBuyerPageFormValues | MtSettingsBreederPageFormValues
  >();
  const onOffOptions = activatedDeactivatedOptions(translate);

  const tabs: AccordionTab[] = useMemo(() => {
    return preferences.map((item, index) => {
      const subgroupPreferences = item.items.map((subgroup) => subgroup.items).flat();
      const groupValue = subgroupPreferences.some((preference) =>
        (values?.contactPreferences ?? []).includes(preference),
      );

      return {
        title: (
          <Styled.CookieCategory>
            <div className="title">{item.title}</div>
          </Styled.CookieCategory>
        ),
        defaultChecked: groupValue,
        content: (
          <Styled.AccordionContent>
            {item.items.map((preference, i) => {
              const { content, items, isDisabled } = preference;
              const isActive = items.some((type) => values?.contactPreferences?.includes(type));

              return (
                <PreferenceList.Item key={`${item.title}-${index}-${i}`}>
                  <PreferenceList.PLabel padded="true">{content}</PreferenceList.PLabel>
                  <InputRadio
                    disabled={mode === 'view' || isDisabled}
                    options={onOffOptions}
                    value={isActive}
                    onSelect={({ value }) => {
                      onChangeContactPreferenceClick(items, value);
                    }}
                  />
                </PreferenceList.Item>
              );
            })}
          </Styled.AccordionContent>
        ),
      };
    });
  }, [mode, onChangeContactPreferenceClick, preferences, values?.contactPreferences, onOffOptions]);

  return <Accordion tabs={tabs} noScroll maxLabelWidth />;
};
